/**
 * QAPage
 *
 * Admin-only page at /qa. Houses QA tooling cards, organized by tab.
 *
 * Routes:
 *   /qa                  → Smoke Tests (default)
 *   /qa/quarterly_data   → Quarterly Data
 */

import React from 'react';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { SmokeTestCard } from 'qa/SmokeTestCard';
import { ServicelineCheckCard } from 'qa/ServicelineCheckCard';
import { ReimbursementCheckCard } from 'qa/ReimbursementCheckCard';

const styles = (theme) => ({
  title: {
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    backgroundColor: theme.palette.primary.accent,
  },
  headerTitle: {
    color: '#FFFFFF',
    fontSize: 24,
    paddingRight: 30,
  },
  container: {
    padding: theme.spacing(3),
  },
});

function QAPage({ classes }) {
  return (
    <>
      <title>QA</title>
      <div className={classes.title}>
        <Typography className={classes.headerTitle}>QA</Typography>
      </div>
      <div className={classes.container}>
        <SmokeTestCard />
        <ServicelineCheckCard />
        <ReimbursementCheckCard />
      </div>
    </>
  );
}

QAPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const StyledQAPage = withStyles(styles)(QAPage);
export { StyledQAPage as QAPage };
